<template>
  <div style="padding-left: 10px">
    <el-row class="search-box">
      <el-input v-model.trim="product_sn" placeholder="请扫SN码" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>
    <StationInfo ref="info" :bu-item="buItem"></StationInfo>

    <div style="margin: 10px 0 0 8px" >
      <FrameForm  ref="frameForm" :component-param="componentParam" :parent-data="buItem" :init-data="initData"></FrameForm>
    </div>
  </div>
</template>

<script>


import StationInfo from "@/views/applications/station/StationInfo.vue";
import {nanoid} from "nanoid";
export default {
  name: "StationTestNoCenter",
  components: {StationInfo},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  provide() {
    return {
      $fn: {
        reset: () => {
          this.product_sn = ''
          this.reset();
        }
      }
    }
  },

  data() {
    return {
      loading:false,
      product_sn: '',
      buItem:{},
      initData:[],

    }
  },
  created() {
    this.loadInitData();
  },

  methods: {
    async search() {
      this.reset()

      this.$refs.frameForm.formInfo = {} //清空作业表单内容
      this.$refs.frameForm.clearMessage()
      if (this.$refs.frameForm.reset) {
        this.$refs.frameForm.reset()
      }


      if (!this.product_sn){
          return this.$refs.searchMessage.showError('SN码不能为空')
      }

      this.loading = true
      await this.$http('buItemSimpleService.queryStationInfo', {
        station_id: 'test_not_center',
        product_sn: this.product_sn
      }, false).then(async data => {
        this.loading = false
        this.buItem = data.buItem || {}
        this.buItem.station_id = 'test_not_center'
        await this.$refs.frameForm.initForm();
        return this.$refs.searchMessage.showSuccess('状态正常，请作业');
      }, errMsg => {
        this.loading = false
        return this.$refs.searchMessage.showError(errMsg)
      })


    },
    reset() {
      this.buItem = {}
      this.$refs.searchMessage.clear()

    },

    loadInitData(){
      let test_list = [];
        test_list.push({
          nanoid: nanoid(),
          test_type:'surface'
        });
        test_list.push({
          nanoid: nanoid(),
          test_type:'function'
        });
        this.initData.test_list = test_list;
    }
  }
}
</script>

<style scoped>

.input {
  height: 32px;
  width: 250px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

</style>